"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logsUtils = void 0;
const utils_1 = require("../../../utils");
const SHOP_START = "bought";
const getSignedNumber = (value) => (value > 0 ? `+${value}` : value);
const buildPriceString = (stats) => {
    const parts = Object.entries(stats)
        .filter(([key, value]) => key !== "gauges" && value !== undefined)
        .map(([key, value]) => `${(0, utils_1.capitalize)(key)}: ${getSignedNumber(value)}`);
    return parts.length ? ` | ${parts.join(". ")}` : "";
};
const buildSkillsString = (skills) => {
    return skills.join(" and ");
};
const getMiniGameTimedOut = (isTimedOut) => isTimedOut ? "due to timeout" : "";
const getLogInfo = (log) => {
    let description = "";
    let formatString = "";
    switch (log.type) {
        case "round": {
            switch (log.action) {
                case "start": {
                    description = log.params.round.toString();
                    formatString = `Round ${description} started`;
                    break;
                }
            }
            break;
        }
        case "education": {
            const { sector } = log.params;
            const sectorString = sector ? ` in ${sector}` : "";
            switch (log.action) {
                case "end": {
                    const { level, result, gamifiedRating, energy, money, satisfaction } = log.params;
                    const resultString = result === "complete" ? "graduated" : "failed education";
                    const gamifiedRatingString = gamifiedRating
                        ? ` | Future-Ready Rating: ${gamifiedRating}`
                        : "";
                    const statChangesString = buildPriceString({
                        energy,
                        money,
                        satisfaction,
                    });
                    // In admin table, stat deltas are separate columns, so keep the description focused on the event details.
                    description = `${resultString} | ${level}${sectorString}${gamifiedRatingString}`;
                    // For player feed, show stat deltas inline (same pattern as other logs).
                    formatString = `You ${resultString} | ${level}${sectorString}${gamifiedRatingString}${statChangesString}`;
                    break;
                }
                case "start": {
                    const { level, energy, money } = log.params;
                    const priceString = buildPriceString({ energy, money });
                    description = `${level}${sectorString}`;
                    formatString = `You started education | ${description}${priceString}`;
                    break;
                }
            }
            break;
        }
        case "skills": {
            switch (log.action) {
                case "increase": {
                    const { sector, energy, money, skills } = log.params;
                    const skillsString = buildSkillsString(skills);
                    const priceString = buildPriceString({ energy, money });
                    description = `${skillsString} in ${sector}`;
                    formatString = `You upskilled ${description}${priceString}`;
                    break;
                }
            }
            break;
        }
        case "reward": {
            switch (log.action) {
                case "receive": {
                    const { title, badge, energy, money, satisfaction } = log.params;
                    const badgeString = badge ? ` ${badge}` : "", bonusesString = buildPriceString({ energy, money, satisfaction });
                    description = `${title}${badgeString} Badge`;
                    formatString = `You have received ${description}${bonusesString}`;
                    break;
                }
            }
            break;
        }
        case "work": {
            switch (log.action) {
                case "apply": {
                    const { energy, money, position } = log.params;
                    const priceString = buildPriceString({ money, energy });
                    description = position;
                    formatString = `You applied for the job as ${description}${priceString}`;
                    break;
                }
                case "tryOther": {
                    const { energy, money, position } = log.params;
                    const priceString = buildPriceString({ money, energy });
                    description = position;
                    formatString = `You tried other companies ${priceString}`;
                    break;
                }
                case "newjob": {
                    description = log.params.position;
                    formatString = `You got a job as ${log.params.position}`;
                    break;
                }
                case "promoted": {
                    description = log.params.position;
                    formatString = `You have been promoted to ${log.params.position}`;
                    break;
                }
                case "cycle": {
                    const { money, satisfaction, energy, position, gauges } = log.params;
                    const workGaugeString = gauges?.work
                        ? `| Work: ${gauges.work > 0 ? `+${gauges.work}` : gauges.work}`
                        : "";
                    const statsString = buildPriceString({ money, satisfaction, energy });
                    description = position + workGaugeString;
                    formatString = `You have worked 1 cycle as ${position}${statsString}`;
                    break;
                }
                case "quit": {
                    const reason = log.params.reason;
                    if (reason === "fail" || reason === "limits") {
                        const reasonString = reason === "fail"
                            ? "because of a job failure"
                            : "due to economic conditions";
                        description = `got fired ${reasonString}`;
                    }
                    else
                        description = "quit the job";
                    description;
                    formatString = `You ${description}`;
                    break;
                }
            }
            break;
        }
        case "shop": {
            const { money, energy } = log.params;
            const priceString = buildPriceString({ money, energy });
            switch (log.action) {
                case "buy": {
                    const { item, level } = log.params;
                    description = `${level} ${item}`;
                    formatString = `You ${SHOP_START} ${description}${priceString}`;
                    break;
                }
                case "travel": {
                    const { level, country } = log.params;
                    description = `${level} travel to ${country}`;
                    formatString = `You ${SHOP_START} ${description}${priceString}`;
                    break;
                }
                case "outfit": {
                    const { name } = log.params;
                    description = name;
                    formatString = `You ${SHOP_START} ${name} skin${priceString}`;
                    break;
                }
            }
            break;
        }
        case "lifeCard": {
            switch (log.action) {
                case "complete": {
                    const { title, choose, lifestyle, energy, money, skills } = log.params;
                    const choseDesc = choose === "Yes" ? ' You chose "Yes"' : "";
                    const choseAdm = choose === "Yes" ? ' Chose "Yes"' : "";
                    const energyDesc = energy
                        ? ` | Energy: ${+energy > 0 ? "+" : ""}${energy}`
                        : "";
                    const bankDesc = money
                        ? ` | Money: ${+money > 0 ? "+" : ""}${money}`
                        : "";
                    const lifestyleDesc = lifestyle ? ` | New status: ${lifestyle}.` : "";
                    const skillsDesc = skills ? ` | Skills improved: ${skills}` : "";
                    description = `${title}${choseAdm}${lifestyleDesc}${skillsDesc}`;
                    formatString = `Life card: ${title}${choseDesc}${energyDesc}${bankDesc}${lifestyleDesc}${skillsDesc}`;
                    break;
                }
                case "disagree": {
                    const { title } = log.params;
                    description = `${title} Chose "No"`;
                    formatString = `Life card: ${title} You chose "No"`;
                    break;
                }
            }
            break;
        }
        case "expenses": {
            switch (log.action) {
                case "deduct": {
                    const { money } = log.params;
                    if (!money) {
                        break;
                    }
                    formatString = `$${Math.abs(+money)} was deducted as living expenses`;
                    break;
                }
            }
            break;
        }
        case "bonus": {
            switch (log.action) {
                case "get": {
                    const { energy, money, satisfaction, performance } = log.params;
                    const bonusString = buildPriceString({ energy, money, satisfaction });
                    description = performance;
                    formatString = `You got performance bonus for your ${performance}${bonusString}`;
                }
            }
            break;
        }
        case "bonusCodes": {
            switch (log.action) {
                case "cheatCode": {
                    const { cheatCode, energy, money, possession, skills, status, gauges, } = log.params;
                    const skillsString = skills
                        ? ` | Skills improved: ${skills.join(", ")}`
                        : "";
                    const statusString = status ? ` | New status: ${status}` : "";
                    const priceString = energy || money ? buildPriceString({ energy, money }) : "";
                    const possessionString = possession
                        ? ` | New possession: ${possession}`
                        : "";
                    let gaugesString = "";
                    if (gauges) {
                        gaugesString = " |";
                        (0, utils_1.entriesObject)(gauges).forEach(([gaugeName, gaugeAdd], index, array) => {
                            const gaugeLabel = (0, utils_1.capitalize)(gaugeName);
                            const dot = index + 1 >= array.length ? "" : ".";
                            gaugesString += ` ${gaugeLabel}: +${gaugeAdd}${dot}`;
                        });
                    }
                    const bonusString = `${priceString}${skillsString}${statusString}${possessionString}`;
                    description = `Code: ${cheatCode}${bonusString}${gaugesString}`;
                    formatString = `You applied a cheat code${bonusString}`;
                    break;
                }
                case "referralCode": {
                    const { money, referralCode } = log.params;
                    const priceString = buildPriceString({ money });
                    description = referralCode;
                    formatString = `You applied a referral code${priceString}`;
                    break;
                }
                case "referralCodeUsed":
                    {
                        const { money, applierName, referralCode } = log.params;
                        const priceString = buildPriceString({ money });
                        description = `${referralCode}. Player name(s): ${applierName}`;
                        formatString = `You received a reward for using your referral code${priceString}`;
                    }
                    break;
            }
            break;
        }
        case "gauges": {
            switch (log.action) {
                case "startMiniGame": {
                    formatString = `You attempted to play a mini game`;
                    break;
                }
                case "failMiniGame": {
                    const { energy, isTimedOut } = log.params;
                    const priceString = buildPriceString({ energy });
                    if (isTimedOut) {
                        description = (0, utils_1.capitalize)(getMiniGameTimedOut(isTimedOut));
                        formatString =
                            "Your 2 minutes are up and have received a reward for your efforts";
                    }
                    else {
                        formatString = "You failed the mini game";
                    }
                    formatString += priceString;
                    break;
                }
                case "passMiniGame": {
                    const { energy, isTimedOut } = log.params;
                    const priceString = buildPriceString({ energy });
                    if (isTimedOut) {
                        description = (0, utils_1.capitalize)(getMiniGameTimedOut(isTimedOut));
                    }
                    formatString = `You have passed the mini game. ${priceString}`;
                    break;
                }
                case "deduct": {
                    const { money } = log.params;
                    formatString = `Gauges deducted. Living expenses: ${money || 0}`;
                    description = `Gauges and living expenses deducted`;
                }
            }
            break;
        }
        case "lifeGoals": {
            switch (log.action) {
                case "change": {
                    const { goals } = log.params;
                    const goalsString = goals
                        .map(({ goal }, index) => {
                        let text = goal;
                        if (index === 0) {
                            text += " (Priority)";
                        }
                        return text;
                    })
                        .join(", ");
                    description = goalsString;
                    formatString = `You have chosen your life goals: ${goalsString}`;
                    break;
                }
                case "confirm": {
                    const { goal, money, satisfaction, energy } = log.params;
                    const statsString = buildPriceString({ energy, money, satisfaction });
                    description = goal;
                    formatString = `You have achieved your life goal: ${goal}${statsString}`;
                    break;
                }
            }
            break;
        }
        case "charity":
        case "hobby": {
            const itemString = log.type === "charity"
                ? "You have done some charity:"
                : "You have participated in a hobby:";
            switch (log.action) {
                case "do": {
                    const { item, option, optionSettings, energy, money, satisfaction } = log.params;
                    const countryString = optionSettings?.country
                        ? ` in ${optionSettings.country}`
                        : "";
                    const bonusString = buildPriceString({
                        energy,
                        money,
                        satisfaction,
                    });
                    description = `${item.item} - ${option.option}${countryString}`;
                    formatString = `${itemString} ${description}${bonusString}`;
                    break;
                }
            }
            break;
        }
        case "specialJob": {
            const { job } = log.params;
            description = `Special Job: ${job}`;
            const articleJob = (0, utils_1.insertArticle)(job);
            switch (log.action) {
                case "reject": {
                    formatString = `You have rejected a special job offer as  ${articleJob}`;
                    break;
                }
                case "accept":
                case "outome": {
                    const { satisfaction, energy, money } = log.params;
                    const statsString = buildPriceString({
                        energy,
                        money,
                        satisfaction,
                    });
                    if (log.action === "accept") {
                        formatString = `You have accepted a special job offer as ${articleJob}${statsString}`;
                    }
                    if (log.action === "outome") {
                        formatString = `You have worked in your special job as an ${articleJob}${statsString}`;
                    }
                    break;
                }
            }
            break;
        }
        case "marriage":
        case "children": {
            switch (log.action) {
                case "yes":
                case "outcome": {
                    const { doorId, energy, money, satisfaction } = log.params;
                    const statsString = buildPriceString({
                        energy,
                        money,
                        satisfaction,
                    });
                    const doorNumber = +doorId.replace(log.type, "");
                    if (log.action === "yes") {
                        const { description: doorDescription } = log.params;
                        formatString = `You have chosen door #${doorNumber} for ${log.type}${statsString}`;
                        description = `Door #${doorNumber} - ${doorDescription}`;
                    }
                    if (log.action === "outcome") {
                        formatString = `You have contributed to your ${log.type} and it has benefitted your life${statsString}`;
                        description = `Door #${doorNumber}`;
                    }
                    break;
                }
                case "no": {
                    formatString = `You have said no to ${log.type}`;
                    break;
                }
            }
        }
    }
    return { description, formatString };
};
const logToString = (log) => {
    let gauges = "";
    if (log.params.gauges) {
        const gaugeChanges = (0, utils_1.entriesObject)(log.params.gauges)
            .map(([gaugeName, gaugeValue]) => {
            if (!gaugeValue) {
                return "";
            }
            const plus = gaugeValue > 0 ? "+" : "";
            return `${(0, utils_1.capitalize)(gaugeName)}: ${plus}${gaugeValue}`;
        })
            .join(", ");
        gauges = ` | Gauges: ${gaugeChanges}`;
    }
    const bankAccount = log.params.money !== undefined ? ` | Bank Account: ${log.playerMoney}` : "";
    return `${getLogInfo(log).formatString}${gauges}${bankAccount}`;
};
exports.logsUtils = {
    getLogInfo,
    logToString,
};
